import {useAppDispatch, useAppSelector} from "../../store/store";
import {useEffect, useState} from "react";
import {
  resetGenres,
  setFilterChanged,
  setGenres,
  setTemporaryCounter,
  setTemporaryGenres
} from "../../store/slices/filters.slice";
import styles from "./styles/FilterComponents.module.scss";
import Header from "../../components/header/Header";
import {ROUTES} from "../../constants/routes";
import GenresModule from "./components/GenresModule";
import Button from "../../components/shared/Button/Button";
import Footer from "../../components/footer/Footer";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import useWindowSize from "../../hooks/useWindowSize";
import {cleanUpFeedPage} from "../../store/slices/feed.slice";

const Filters = () => {
  const dispatch = useAppDispatch()
  const genres = useAppSelector((state: any) => state.filters.genres)
  const maxYear = useAppSelector((state: any) => state.filters.maxYear)

  const { windowSize } = useWindowSize();
  const isMobile = windowSize === "mobile";

  const navigate = useNavigate();
  const { t } = useTranslation();

  const [genresValue, setGenresValue] = useState<any>([])

  useEffect(() => {
    setGenresValue(genres);
  }, [genres]);

  useEffect(() => {
    if (genresValue.length) {
      dispatch(setFilterChanged(true))
    } else {
      dispatch(setFilterChanged(false))
    }
    dispatch(setTemporaryCounter({genres: genresValue, period: [1980, maxYear]}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genresValue, dispatch]);

  const submitFilters = () => {
    dispatch(cleanUpFeedPage())
    dispatch(setGenres(genresValue))

    const timeout =  setTimeout(() => {
      navigate(-1);
      clearTimeout(timeout);
    }, 300)
  }

  const setGenresValueHandler = (itemId: any) => {
    setGenresValue((currentIds: any) => {
      if (currentIds.includes(itemId)) {
        return currentIds.filter((currentId: any) => currentId !== itemId);
      } else {
        return [...currentIds, itemId];
      }
    });
    dispatch(setTemporaryGenres(itemId))
  }

  const clearGenresHandler = () => {
    setGenresValue([]);
    dispatch(resetGenres());
  }

  return (
    <div className={styles.filtersModalWrapper}>
      <Header source={ROUTES.FILTERS} clickHandler={() => {}} className={styles.headerWrapperFilters}/>
      <div className={`${isMobile ? styles.contentWrapperMobile : styles.contentWrapper}`}>
        <GenresModule
          fromPageFlag={false}
          isMobile={isMobile}
          setGenresValue={setGenresValueHandler}
          genres={genresValue}
          clearFiltersHandler={clearGenresHandler}
        />
        <div className={styles.btnsWrapper}>
          <Button submit={submitFilters} title={t('apply')} className={styles.submitButton}/>
        </div>
      </div>
      <div style={{height: '50px'}}/>
      <Footer source={''}/>
    </div>
  )
};

export default Filters;
